// extracted by mini-css-extract-plugin
export default {"container":"b_OiWy","borderMargin":"L2GJox","repositionCoverButton":"Nxhl1H","coverIsMoving":"fksJ3o"};